import BigNumber from 'bignumber.js'

export const convertFromWei = (balance: BigNumber, decimals = 18) => {
  const displayBalance = new BigNumber(balance).dividedBy(
    new BigNumber(10).pow(decimals),
  )
  return displayBalance
}

export const convertToWei = (balance: BigNumber, decimals = 18) => {
  const displayBalance = new BigNumber(balance).multipliedBy(
    new BigNumber(10).pow(decimals),
  )
  return displayBalance
}
